export const GET_VENDOR = "GET_VENDOR";
export const SET_VENDOR = "SET_VENDOR";
